import { useLabel } from "@/core/context/LabelsContext"
import { openGoogleConnectionPage } from "@/user/settings/subtabs/connections/ConnectGoogleConnectionButton"
import { openOutlookConnectionPage } from "@/user/settings/subtabs/connections/ConnectOutlookConnectionButton"
import GoogleCalendarIntegrationIcon from "@assets/images/integration-icons/google-calendar-integration-icon.svg"
import OutlookIntegrationIcon from "@assets/images/integration-icons/outlook-integration-icon.svg"
import { DiscoButton, DiscoModal, DiscoText } from "@disco-ui"
import { Grid } from "@material-ui/core"
import useFeatureFlags from "@utils/hook/useFeatureFlags"
import { observer } from "mobx-react-lite"

interface MemberOnboardingCalendarConnectionModalProps {
  isOpen: boolean
  onClose: () => void
}

function MemberOnboardingCalendarConnectionModal({
  isOpen,
  onClose,
}: MemberOnboardingCalendarConnectionModalProps) {
  const { googleCalendarConnection } = useFeatureFlags()
  const organizationLabel = useLabel("organization")

  return (
    <DiscoModal
      isOpen={isOpen}
      onClose={onClose}
      modalContentLabel={"Select a calendar to connect"}
      minWidth={"550px"}
      title={"Connect a calendar"}
      testid={"MemberOnboardingCalendarConnectionModal"}
      buttons
      body={
        <>
          <DiscoText marginBottom={2}>
            {`Connect a calendar to sync events in this ${organizationLabel.singularLowercase} with your personal calendar. You can only connect one calendar at a time and you can always disconnect it later via your profile settings.`}
          </DiscoText>
          <Grid container spacing={2}>
            {googleCalendarConnection && (
              <Grid item xs={12} md={6}>
                <DiscoButton
                  variant={"outlined"}
                  color={"grey"}
                  leftIcon={<GoogleCalendarIntegrationIcon />}
                  onClick={() => {
                    openGoogleConnectionPage()
                    onClose()
                  }}
                >
                  {"Connect Google Calendar"}
                </DiscoButton>
              </Grid>
            )}
            <Grid item xs={12} md={6}>
              <DiscoButton
                variant={"outlined"}
                color={"grey"}
                leftIcon={<OutlookIntegrationIcon />}
                onClick={() => {
                  openOutlookConnectionPage()
                  onClose()
                }}
              >
                {"Connect Outlook Calendar"}
              </DiscoButton>
            </Grid>
          </Grid>
        </>
      }
    />
  )
}

export default observer(MemberOnboardingCalendarConnectionModal)
